import Group from 'components/utils/Group'
import OfferInclusionItem from 'components/Common/Inclusions/OfferInclusionItem'
import Heading from 'LuxKit/Typography/Heading'
import { useIntl } from 'react-intl'
import type { DrawerHotelInclusion } from './types'

interface Props {
  inclusions: Array<DrawerHotelInclusion>
}

function HotelDetailInclusions({ inclusions }: Props) {
  const intl = useIntl()

  return (
    <Group direction="vertical" gap={12}>
      <Heading variant="heading5">
        {intl.formatMessage({
          id: 'SykvufinWqBDatL8mNWm',
          defaultMessage: 'Exclusive inclusions',
          description: 'Section heading for hotel exclusive inclusions section',
        })}
      </Heading>
      <Group direction="vertical" gap={4}>
        {inclusions.map((inclusion) => (
          <OfferInclusionItem key={inclusion.id} inclusion={inclusion} />
        ))}
      </Group>
    </Group>
  )
}

export default HotelDetailInclusions
